import React from 'react';

const DataDataAnalytics = () => {
  return (
    <div className="container-fluid p-4">
      <div className="row">
        <div className="col-12">
          <h1 className="mb-4">Data Analytics</h1>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Advanced Data Analysis & Insights</h5>
              <p className="card-text">
                Perform advanced analytics and generate insights from organizational data.
              </p>
              <div className="row mt-4">
                <div className="col-md-4">
                  <div className="card border-primary">
                    <div className="card-body">
                      <h6 className="card-title">Data Sources</h6>
                      <ul className="list-unstyled">
                        <li><i className="bi bi-check-circle text-success"></i> Customer Data</li>
                        <li><i className="bi bi-check-circle text-success"></i> Sales Data</li>
                        <li><i className="bi bi-check-circle text-success"></i> Marketing Data</li>
                        <li><i className="bi bi-clock text-warning"></i> External APIs</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card border-info">
                    <div className="card-body">
                      <h6 className="card-title">Analytics Models</h6>
                      <ul className="list-unstyled">
                        <li><i className="bi bi-graph-up"></i> Predictive Models</li>
                        <li><i className="bi bi-pie-chart"></i> Segmentation</li>
                        <li><i className="bi bi-bar-chart"></i> Trend Analysis</li>
                        <li><i className="bi bi-speedometer2"></i> Performance KPIs</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card border-success">
                    <div className="card-body">
                      <h6 className="card-title">Insights Generated</h6>
                      <div className="text-center">
                        <h3 className="text-success">247</h3>
                        <small>This month</small>
                      </div>
                      <div className="mt-2">
                        <small className="text-muted">+23% from last month</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataDataAnalytics;